import { render, staticRenderFns } from "./AccessesCrudPage.vue?vue&type=template&id=1577f53a&"
import script from "./AccessesCrudPage.vue?vue&type=script&lang=js&"
export * from "./AccessesCrudPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports